export default "__VITE_ASSET__b089a171__"